import { RoleType } from "@/models/user.model";
import React from "react";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

interface Props {
  selectedRole: RoleType;
  setSelectedRole: React.Dispatch<React.SetStateAction<RoleType>>;
  isReadOnly?: boolean;
}

const roles = Object.entries(RoleType).map(([key, value]) => ({
  key,
  value,
}));

function UserRoleDropdown({
  selectedRole,
  setSelectedRole,
  isReadOnly,
}: Props) {
  return (
    <div className="flex flex-col w-full gap-2">
      <Label>User Role</Label>
      <div className="text-xs text-gray-500 ">
        {selectedRole === RoleType.ADMIN
          ? "Has full administrative control over employees."
          : "Has basic employee access."}
      </div>
      <Select
        value={selectedRole}
        onValueChange={(value: RoleType) => setSelectedRole(value)}
        disabled={isReadOnly ?? false}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={selectedRole} />
        </SelectTrigger>
        <SelectContent>
          {roles.map((role) => (
            <SelectItem key={role.key} value={role.value}>
              {role.value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default UserRoleDropdown;
